export const styles = {
  errorMessage: {
    marginBottom: '10px',
    paddingLeft: '24px',
  },
  line: {
    width: '2px',
    height: '30px',
    backgroundColor: 'rgba(0, 0, 0, .2)',
  },
  popupItem: { fontSize: '10px', color: '#7C7C7C' },
  wrapperSelect: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '10px',
    marginBottom: '10px',
    paddingLeft: '24px',
    minWidth: '590px',
  },
  header: {
    width: '620px',
    height: '30px',
    backgroundColor: '#273754',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: '600',
    color: '#FFFFFF',
    borderRadius: '10px 10px 0 0',
    paddingLeft: '28px',
  },
  body: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    width: '620px',
    boxShadow: '0px 4px 4px 0px #b8b8b8',
    borderRadius: '0 0 4px 4px',
  },
  timePicker: {
    marginLeft: '3rem',
  },
}
